module.exports = __webpack_public_path__ + "static/media/canvas_img.d88c54f1.svg";